import { DELETE, GET, POST, PUT } from "../API";

export const createConferenceApiCall = (dataObj, onSuccess, onError) => {
  POST(`/api/v1/conferences/create`, dataObj, onSuccess, onError);
};

export const updateConferenceApiCall = (dataObj, onSuccess, onError) => {
  PUT(`/api/v1/conferences/update`, dataObj, onSuccess, onError);
};

export const getAllConferencesApiCall = (onSuccess, onError) => {
  GET(`/api/v1/conferences`, onSuccess, onError);
};

export const getPublicConferenceDetailsApiCall = (
  conferenceId,
  onSuccess,
  onError
) => {
  GET(`/api/v1/public/conferences/${conferenceId}`, onSuccess, onError);
};

export const deleteConferenceApiCall = (conferenceId, onSuccess, onError) => {
  DELETE(`/api/v1/conferences/${conferenceId}`, onSuccess, onError);
};

export const joinConferenceWithTokenApiCall = (
  token,
  linkToken,
  onSuccess,
  onError
) => {
  POST(
    `/api/v1/public/conferences/join`,
    { token: token || linkToken || null },
    onSuccess,
    onError
  );
};

export const registerPublicConferenceApiCall = (
  id,
  firstName,
  lastName,
  email,
  onSuccess,
  onError
) => {
  const data = {
    first_name: firstName,
    last_name: lastName,
    email,
  };
  POST(`/api/v1/public/conferences/${id}/registrations`, data, onSuccess, onError);
};

export const listConferenceRegistrationsApiCall = (id, onSuccess, onError) => {
  GET(`/api/v1/conferences/${id}/registrations`, onSuccess, onError);
};

export const approveConferenceRegistrationApiCall = (
  id,
  registrationId,
  onSuccess,
  onError
) => {
  POST(
    `/api/v1/conferences/${id}/approve_registration`,
    { registration_id: registrationId },
    onSuccess,
    onError
  );
};

export const denyConferenceRegistrationApiCall = (
  id,
  registrationId,
  onSuccess,
  onError
) => {
  POST(
    `/api/v1/conferences/${id}/deny_registration`,
    { registration_id: registrationId },
    onSuccess,
    onError
  );
};

export const joinConferenceCallApiCall = (id, onSuccess, onError) => {
  POST(`/api/v1/conferences/${id}/call`, {}, onSuccess, onError);
};

export const getConferenceCallDetailsApiCall = (id, onSuccess, onError) => {
  GET(`/api/v1/conferences/${id}/call_details`, onSuccess, onError);
};

export const endConferenceApiCall = (id, onSuccess, onError) => {
  POST(`/api/v1/conferences/${id}/end`, {}, onSuccess, onError);
};

export const getConferenceFloorTokenApiCall = (id, onSuccess, onError) => {
  POST(`/api/v1/conferences/${id}/floor_token`, {}, onSuccess, onError);
};

export const getConferencePlaybackTokenApiCall = (id, playbackId, onSuccess, onError) => {
  POST(
    `/api/v1/conferences/${id}/playback_token`,
    { playback_id: playbackId },
    onSuccess,
    onError
  );
};

export const getConferenceAudienceApiCall = (id, onSuccess, onError) => {
  GET(`/api/v1/conferences/${id}/audience`, onSuccess, onError);
};

export const checkConferenceCallChatConversation = (conferenceCallId, onSuccess, onError) => {
  GET(`/api/v1/conferences/conference_calls/${conferenceCallId}/conversation`, onSuccess, onError);
};

export const createConferenceCallChatConversation = (conferenceCallId, onSuccess, onError) => {
  POST(`/api/v1/conferences/conference_calls/${conferenceCallId}/conversation`, {}, onSuccess, onError);
};

export const getConferencePollsApiCall = (conferenceId, onSuccess, onError) => {
  GET(`/api/v1/conferences/${conferenceId}/polls`, onSuccess, onError);
};

export const createPollQuestionApiCall = (conferenceId, questionText, answerType, position, onSuccess, onError) => {
  const data = {
    question_text: questionText,
    answer_type: answerType,
    position: position
  };
  POST(`/api/v1/conferences/${conferenceId}/polls`, data, onSuccess, onError);
};

export const updatePollQuestionApiCall = (questionId, questionText, answerType, onSuccess, onError) => {
  const data = {};
  if (questionText !== undefined) data.question_text = questionText;
  if (answerType !== undefined) data.answer_type = answerType;
  PUT(`/api/v1/conferences/polls/${questionId}`, data, onSuccess, onError);
};

export const deletePollQuestionApiCall = (questionId, onSuccess, onError) => {
  DELETE(`/api/v1/conferences/polls/${questionId}`, onSuccess, onError);
};

export const createPollOptionApiCall = (questionId, optionText, position, onSuccess, onError) => {
  const data = {
    option_text: optionText,
    position: position
  };
  POST(`/api/v1/conferences/polls/${questionId}/options`, data, onSuccess, onError);
};

export const updatePollOptionApiCall = (optionId, optionText, position, onSuccess, onError) => {
  const data = {
    option_text: optionText,
    position: position
  };
  PUT(`/api/v1/conferences/poll_options/${optionId}`, data, onSuccess, onError);
};

export const deletePollOptionApiCall = (optionId, onSuccess, onError) => {
  DELETE(`/api/v1/conferences/poll_options/${optionId}`, onSuccess, onError);
};

export const reorderPollQuestionsApiCall = (conferenceId, positions, onSuccess, onError) => {
  const data = { positions };
  POST(`/api/v1/conferences/${conferenceId}/polls/reorder`, data, onSuccess, onError);
};

export const reorderPollOptionsApiCall = (questionId, positions, onSuccess, onError) => {
  const data = { positions };
  POST(`/api/v1/conferences/polls/${questionId}/options/reorder`, data, onSuccess, onError);
};

export const launchPollApiCall = (questionId, onSuccess, onError) => {
  POST(`/api/v1/conferences/polls/${questionId}/launch`, {}, onSuccess, onError);
};

export const endPollApiCall = (questionId, onSuccess, onError) => {
  POST(`/api/v1/conferences/polls/${questionId}/end_poll`, {}, onSuccess, onError);
};

export const getPollResultsApiCall = (questionId, onSuccess, onError) => {
  GET(`/api/v1/conferences/polls/${questionId}/results`, onSuccess, onError);
};

export const submitPollResponseApiCall = (questionId, selectedOptionIds, onSuccess, onError) => {
  const data = {
    selected_option_ids: selectedOptionIds
  };
  POST(`/api/v1/conferences/polls/${questionId}/responses`, data, onSuccess, onError);
};

export const toggleConferenceChatApiCall = (conferenceId, allowChat, onSuccess, onError) => {
  POST(`/api/v1/conferences/${conferenceId}/toggle_chat`, { allow_chat: allowChat }, onSuccess, onError);
};